module.exports = __webpack_public_path__ + "static/img/about-certificate-02.db0fcdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about-certificate-02.jpg
// module id = N/mY
// module chunks = 1